function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.49998,
  cy: 8.5,
  r: 7.72727,
  stroke: "#FEFDF8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3636 7.34091C12.3294 6.88906 12.2756 6.45002 12.2039 6.02735C11.6854 2.97236 10.2327 0.772728 8.5217 0.772728C6.37588 0.772728 4.63635 4.23235 4.63635 8.5C4.63635 12.7677 6.37588 16.2273 8.5217 16.2273C10.0268 16.2273 11.332 14.5252 11.9773 12.0362",
  stroke: "#FEFDF8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.65911 12.3636C10.111 12.3295 10.55 12.2756 10.9727 12.2039C14.0277 11.6854 16.2273 10.2327 16.2273 8.52171C16.2273 6.3759 12.7677 4.63637 8.50002 4.63637C4.23237 4.63637 0.77275 6.3759 0.77275 8.52171C0.77275 10.0002 2.41508 11.2858 4.83248 11.9424",
  stroke: "#FEFDF8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8181 6.95454L12.3636 8.5L13.9091 6.95454",
  stroke: "#FEFDF8",
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0454 10.8182L8.49996 12.3636L10.0454 13.9091",
  stroke: "#FEFDF8",
  strokeLinecap: "square"
});

var SvgVue360 = function SvgVue360(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVue360, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vue360.f32120a6.svg";
export { ForwardRef as ReactComponent };